<template>
  <vuex-table
    :fields="fields"
    :filter_items="filter_items"
    :show_per_page="false"
    :auto_start="false"
    :foot_clone="true"
    :no_footer_sorting="true"
    total_caption="group_by"
    table_store="voice/stats/general"
  />
</template>

<script>
  import { seconds_to_time } from '@shared/helpers/time';

  export default {
    props: {
      filter_items: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      fields: function () {
        return [
          {
            key: 'group_by',
            label: this.$t('voice.stats.general.field.group'),
            sortable: false,
            class: 'column-sticky',
            thStyle: {
              minWidth: '200px'
            }
          },

          {
            key: 'total',
            label: this.$t('voice.stats.general.field.total'),
            sortable: false,
            thStyle: {
              minWidth: '100px'
            }
          },

          ...['answered', 'busy', 'no_answer', 'failed'].map((i) => ({
            key: i,
            label: this.$t(`voice.call.status.${i}`),
            sortable: false,
            thStyle: {
              minWidth: '170px'
            }
          })),

          {
            key: 'asr',
            label: this.$t('voice.stats.general.field.asr'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            },

            formatter: (val) => this.$numeral.percentage(val),
            percentage: true
          },

          {
            key: 'acd',
            label: this.$t('voice.stats.general.field.acd'),
            sortable: false,
            thStyle: {
              minWidth: '120px'
            },
            formatter: (val) => seconds_to_time(Math.round(val)),
            time: true
          },

          {
            key: 'duration',
            label: this.$t('voice.stats.general.field.duration'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            },

            formatter: (val) => seconds_to_time(val),
            time: true
          },

          {
            key: 'duration_billed',
            label: this.$t('voice.stats.general.field.duration_billed'),
            sortable: false,
            thStyle: {
              minWidth: '200px'
            },
            formatter: (value) => seconds_to_time(value)
          },

          {
            key: 'op_sum',
            label: this.$t('voice.stats.general.field.cost'),
            sortable: false,
            thStyle: {
              minWidth: '150px'
            },

            formatter: (val) => this.$numeral.currency(val)
          }
        ];
      }
    }
  };
</script>
